import { Card, CardContent, CardHeader } from "@/components/ui/card";

/** What `/signup` shows when the app doesn't let people make their own account. */
export function SignupClosed() {
  return (
    <Card className="border-border/60 shadow-sm">
      <CardHeader className="space-y-1 text-center pb-2">
        <h1 className="font-display text-2xl font-bold">Accounts are by invitation</h1>
        <p className="text-muted-foreground text-sm">
          Ask an admin of this app to create an account for you.
        </p>
      </CardHeader>
      <CardContent>
        <p className="text-center text-sm text-muted-foreground mt-2">
          Already have one?{" "}
          <a href="/login" className="text-primary hover:underline underline-offset-4">
            Sign in
          </a>
        </p>
      </CardContent>
    </Card>
  );
}
